(() => {
  if (window.__shopifyFormsCustomStylesLoaded) {
    return;
  }

  window.__shopifyFormsCustomStylesLoaded = true;

  const STYLE_ID = "shopify-forms-custom-styles";

  const customStyles = `
    :host,
    [data-form-root="true"] {
      --form-field-border-focused:
        0 0 0 0.1rem rgb(var(--color-button, 85, 131, 53)),
        0 0 0 0.4rem rgba(var(--color-shadow, 12, 12, 12), 0.12) !important;
    }

    div[class*="_formFieldContainer_"] {
      overflow: visible !important;
    }

    form[class*="_formFieldset_"],
    fieldset[class*="_formFieldset_"],
    div[class*="_formFieldset_"] {
      padding: 0 0.4rem !important;
      padding: 0.4rem !important;
      overflow: visible !important;
    }

    textarea[class*="_textArea_"],
    textarea[class*="_formInputField_"] {
      min-height: 12rem !important;
      resize: vertical !important;
    }

    input[class*="_formInputField_"],
    textarea[class*="_formInputField_"],
    textarea[class*="_textArea_"],
    select[class*="_formInputField_"] {
      box-sizing: border-box !important;
      border-color: rgba(var(--color-foreground, 18, 18, 18), 0.18) !important;
      color: rgb(var(--color-foreground, 18, 18, 18)) !important;
      transition:
        border-color var(--duration-short, 200ms) ease,
        box-shadow var(--duration-short, 200ms) ease !important;
    }

    input[class*="_formInputField_"]:hover,
    textarea[class*="_formInputField_"]:hover,
    textarea[class*="_textArea_"]:hover,
    select[class*="_formInputField_"]:hover,
    input[class*="_formInputField_"]:focus,
    input[class*="_formInputField_"]:focus-visible,
    textarea[class*="_formInputField_"]:focus,
    textarea[class*="_formInputField_"]:focus-visible,
    select[class*="_formInputField_"]:focus,
    select[class*="_formInputField_"]:focus-visible {
      border-color: rgb(var(--color-button, 85, 131, 53)) !important;
      outline: none !important;
      box-shadow: var(--form-field-border-focused) !important;
    }

    label[class*="_formInputFieldLabel_"] {
      color: rgba(var(--color-foreground, 18, 18, 18), 0.65) !important;
    }

  `;

  const injectStyles = (embed) => {
    if (!embed.shadowRoot) {
      return false;
    }

    if (embed.shadowRoot.getElementById(STYLE_ID)) {
      return true;
    }

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = customStyles;

    embed.shadowRoot.appendChild(style);

    return true;
  };

  const injectAllForms = () => {
    document.querySelectorAll("shopify-forms-embed").forEach(injectStyles);
  };

  const init = () => {
    injectAllForms();

    const observer = new MutationObserver(injectAllForms);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    let attempts = 0;

    const interval = window.setInterval(() => {
      injectAllForms();
      attempts += 1;

      if (attempts >= 40) {
        window.clearInterval(interval);
      }
    }, 250);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
